module.exports = __webpack_public_path__ + "static/media/Icon-Upload-Computer.cba5921d.svg";